import { ContainerBadgeComponent } from '@modules/common/components/container-badge/container-badge.component';
import { DetailBreadcrumbsComponent } from '@modules/common/components/detail-breadcrumbs/detail-breadcrumbs.component';
import { RowStatusMarkComponent } from '@modules/team-list-state/row-status-mark.component';
import { ItemReviewComponent } from '@modules/common/components/item-review/item-review.component';
import { TenancySelectorComponent } from '@modules/common/components/tenancy-selector/tenancy-selector.component';
import { ItemHandoverComponent } from '@modules/common/components/item-handover/item-handover.component';
import { CanPurgeTeamItemPipe } from '@modules/common/pipes/can-purge-team-item.pipe';
import { RailMenuComponent } from '@modules/common/components/rail-menu/rail-menu.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertComponent } from '@frontendlib/components/components/alert/alert.component';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { Checkbox2Component } from '@frontendlib/components/controls/checkbox/checkbox2.component';
import { ContextMenuDividerComponent } from '@frontendlib/components/features/popover/components/context-menu-divider/context-menu-divider.component';
import { ContextMenuHeadingComponent } from '@frontendlib/components/features/popover/components/context-menu-heading/context-menu-heading.component';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { ContextMenuStateIndicatorComponent } from '@frontendlib/components/features/popover/components/context-menu-state-indicator/context-menu-state-indicator.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { LoadingIndicatorComponent } from '@frontendlib/components/components/loading-indicator/loading-indicator.component';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { SearchLocationBadgeComponent } from '@frontendlib/components/components/search-location-badge/search-location-badge.component';
import { AlertModule } from '@modules/alert/alert.module';
import { AttachmentsModule } from '@modules/attachments/attachments.module';
import { CalendarsListComponent } from '@modules/calendar-app/components/calendars-list/calendars-list.component';
import { EventRsvpButtonsComponent } from '@modules/calendar-app/components/event-rsvp-buttons/event-rsvp-buttons.component';
import { EventsSideBarComponent } from '@modules/calendar-app/components/side-bar/side-bar.component';
import { SidebarContextMenuComponent } from '@modules/calendar-app/components/sidebar-context-menu/sidebar-context-menu.component';
import { CommentsModule } from '@modules/comments/comments.module';
import { ListItemSeparatorComponent } from '@modules/common/components/list/list-items-separator/list-items-separator.component';
import { ListLoadErrorComponent } from '@modules/common/components/list/list-load-error/list-load-error.component';
import { ListSelectionBarComponent } from '@modules/common/components/list/list-selection-bar/list-selection-bar.component';
import { Pagination2Component } from '@modules/common/components/pagination/pagination2.component';
import { SidebarItemComponent } from '@modules/common/components/sidebar-item/sidebar-item.component';
import { ItemDescriptionFieldComponent } from '@modules/common/components/item-description/item-description-field.component';
import { StitchTimestampsComponent } from '@modules/common/components/stitch-timestamps/stitch-timestamps.component';
import { KnowledgeMarkerSelectionTooltipDirective } from '@modules/common/directives/knowledge-marker-selection-tooltip.directive';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { ConnectionsModule } from '@modules/connections/connections.module';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';
import { LinkedInfoListComponent } from '@modules/elements/components/link-info/linked-info-list/linked-info-list.component';
import { EntityHubSearchComponent } from '@modules/elements/components/entity-hub/entity-hub-search/entity-hub-search.component';
import { StitchHubComponent } from '@modules/elements/components/stitch-hub/stitch-hub.component';
import { CalendarQuickFormComponent } from '@modules/elements/components/quick-forms/calendar-quick-form/calendar-quick-form.component';
import { CalendarContextMenuDirective } from '@modules/elements/directives/calendar-context-menu.directive';
import { EventContextMenuDirective } from '@modules/elements/directives/event-context-menu.directive';
import { DropdownMonthYearInputComponent } from '@modules/form-controls/components/dropdown-month-year-input/dropdown-month-year-input.component';
import { EditableTextareaComponent } from '@modules/form-controls/components/editable-textarea/editable-textarea.component';
import { QuickActionComponent } from '@modules/form-controls/components/quick-action/quick-action.component';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { HideTooltipEventTitleFormatter } from '@modules/full-calendar/providers/hide-tooltip-event-title-formatter.provider';
import { KnotsModule } from '@modules/knots/knots.module';
import { ScrollModule } from '@modules/scroll/scroll.module';
import { TagsModule } from '@modules/tags/tags.module';
import { ToArrayPipe } from '@modules/utils/pipes/array/to-array.pipe';
import { UtilsModule } from '@modules/utils/utils.module';
import { MailAppContextDirective } from '@modules/messages/directives/app-mail-app-context.directive';
import { MessagesModule } from '@modules/messages/messages.module';
import { CalendarEventTitleFormatter } from 'angular-calendar';
import { CommonModule as AppCommonModule } from '../common/common.module';
import { ElementsModule } from '../elements/elements.module';
import { FullCalendarModule } from '../full-calendar/full-calendar.module';
import { UserAvatarModule } from '../user-avatar/user-avatar.module';
import { CalendarFormComponent } from './components/calendar-form/calendar-form.component';
import { CalendarSectionsComponent } from './components/calendar-sections/calendar-sections.component';
import { CalendarsListContextMenuComponent } from './components/calendars-list-context-menu/calendars-list-context-menu.component';
import { EventFormComponent } from './components/event-form/event-form.component';
import { EventPopoverFormComponent } from './components/event-popover-form/event-popover-form.component';
import { EventsListContainerComponent } from './components/events-list-container/events-list-container.component';
import { EventsListContextMenuComponent } from './components/events-list-context-menu/events-list-context-menu.component';
import { EventsListComponent } from './components/events-list/events-list.component';
import { TimeRangeEventsListComponent } from './components/events-list/time-range-events-list.component';
import { FullCalendarMonthComponent } from './components/full-calendar-month/full-calendar-month.component';
import { FullCalendarComponent } from './components/full-calendar/full-calendar.component';
import { CalendarDateNavComponent } from './components/calendar-date-nav/calendar-date-nav.component';
import { MainViewComponent } from './components/main-view/main-view.component';
import { MeetingLinkFieldComponent } from './components/meeting-link-field/meeting-link-field.component';
import { CalendarPaginationComponent } from './components/pagination/calendar-pagination.component';
import { ParticipantsInputComponent } from './components/participants-input/participants-input.component';
import { SideBarCalendarsTreeComponent } from './components/side-bar-calendars-tree/side-bar-calendars-tree.component';
import { SideBarCalendarsComponent } from './components/side-bar-calendars/side-bar-calendars.component';
import { StickyEventsListComponent } from './components/sticky-events-list/sticky-events-list.component';
import { CalendarsListContextMenuDirective } from './directives/calendars-list-context-menu.directive';
import { EventsListContextMenuDirective } from './directives/events-list-context-menu.directive';
import { SidebarContextMenuDirective } from './directives/sidebar-context-menu.directive';
import { IsEventCutPipe } from './pipes/is-event-cut.pipe';
import { TitleByEventsFilterPipe } from './pipes/title-by-events-filter.pipe';
import { EventInviteConfirmationService } from './services/event-invite-confirmation.service';
import { EventInviteService } from './services/event-invite.service';

@NgModule({
  imports: [
    ContainerBadgeComponent,
    DetailBreadcrumbsComponent,
    RowStatusMarkComponent,
    ItemReviewComponent,
    TenancySelectorComponent,
    ItemHandoverComponent,
    CanPurgeTeamItemPipe,
    SearchLocationBadgeComponent,
    AlertModule,
    AppCommonModule,
    AttachmentsModule,
    CommentsModule,
    CommonModule,
    ConnectionsModule,
    DragNDropModule,
    ElementsModule,
    FormControlsModule,
    FullCalendarModule,
    KnotsModule,
    MailAppContextDirective,
    MessagesModule,
    MatIconModule,
    IconComponent,
    MatTooltipModule,
    ContextMenuDividerComponent,
    ContextMenuHeadingComponent,
    ContextMenuItemComponent,
    ContextMenuStateIndicatorComponent,
    PopoverDirective,
    ReactiveFormsModule,
    ScrollModule,
    ScrollingModule,
    TagsModule,
    UserAvatarModule,
    UtilsModule,
    ListLoadErrorComponent,
    NoContentStubComponent,
    ListItemSeparatorComponent,
    EditableTextareaComponent,
    KnowledgeMarkerSelectionTooltipDirective,
    StchHighlightTextDirective,
    ListSelectionBarComponent,
    Pagination2Component,
    LoadingIndicatorComponent,
    QuickActionComponent,
    Button2Component,
    ToArrayPipe,
    CalendarPaginationComponent,
    DropdownMonthYearInputComponent,
    CalendarContextMenuDirective,
    EventContextMenuDirective,
    LinkedInfoListComponent,
    EntityHubSearchComponent,
    StitchHubComponent,
    StickyEventsListComponent,
    IsEventCutPipe,
    SidebarItemComponent,
    EventsListComponent,
    ParticipantsInputComponent,
    EventRsvpButtonsComponent,
    MeetingLinkFieldComponent,
    ItemDescriptionFieldComponent,
    CalendarQuickFormComponent,
    StitchTimestampsComponent,
    Checkbox2Component,
    AlertComponent,
    RailMenuComponent,
    CalendarDateNavComponent,
  ],
  exports: [
    CalendarDateNavComponent,
    CalendarFormComponent,
    CalendarsListComponent,
    EventFormComponent,
    EventPopoverFormComponent,
    EventsListComponent,
    EventsListContainerComponent,
    CalendarsListContextMenuDirective,
    EventsListContextMenuDirective,
    EventsSideBarComponent,
    MainViewComponent,
    TitleByEventsFilterPipe,
    TimeRangeEventsListComponent,
  ],
  declarations: [
    CalendarFormComponent,
    CalendarSectionsComponent,
    CalendarsListComponent,
    CalendarsListContextMenuComponent,
    EventFormComponent,
    EventPopoverFormComponent,
    EventsListContainerComponent,
    EventsListContextMenuComponent,
    EventsSideBarComponent,
    FullCalendarComponent,
    FullCalendarMonthComponent,
    MainViewComponent,
    SideBarCalendarsComponent,
    SideBarCalendarsTreeComponent,
    SidebarContextMenuComponent,
    TimeRangeEventsListComponent,

    // Directives
    CalendarsListContextMenuDirective,
    EventsListContextMenuDirective,
    SidebarContextMenuDirective,

    // Pipes
    TitleByEventsFilterPipe,
  ],
  providers: [
    {
      provide: CalendarEventTitleFormatter,
      useClass: HideTooltipEventTitleFormatter,
    },
    EventInviteService,
    EventInviteConfirmationService,
  ],
})
export class CalendarAppModule {}
